(() => {
  'use strict';
  const header = document.getElementById('px-navigation');
  if (!header) return;
  const mega = header.querySelector('.px-nav-mega');
  const triggers = [...header.querySelectorAll('[data-nav-panel]')];
  const panels = [...header.querySelectorAll('.px-nav-panel')];
  const scrim = document.querySelector('.px-nav-scrim');
  const mobile = document.getElementById('nav-mobile-dialog');
  const burger = header.querySelector('.px-nav-burger');
  const desktop = matchMedia('(min-width: 901px)');
  const hasHover = matchMedia('(hover: hover) and (pointer: fine)');
  let current = null;
  let closeTimer = null;
  let hoverTimer = null;
  let keyboardOpening = false;
  let keyboardIntent = false;
  let suppressFocusOpen = false;
  document.addEventListener('keydown', event => { if (['Tab', 'ArrowDown', 'ArrowUp'].includes(event.key)) keyboardIntent = true; }, true);
  document.addEventListener('pointerdown', () => { keyboardIntent = false; keyboardOpening = false; }, true);

  function cancelTimers() {
    clearTimeout(closeTimer);
    clearTimeout(hoverTimer);
  }

  function openPanel(name, fromKeyboard = false) {
    if (!desktop.matches) return;
    cancelTimers();
    const trigger = triggers.find(button => button.dataset.navPanel === name);
    if (!trigger) return;
    current = name;
    keyboardOpening = fromKeyboard;
    header.classList.add('is-open');
    document.body.classList.add('px-nav-expanded');
    mega.inert = false;
    mega.setAttribute('aria-hidden', 'false');
    for (const button of triggers) button.setAttribute('aria-expanded', String(button === trigger));
    for (const panel of panels) {
      const active = panel.id === `nav-${name}`;
      panel.classList.toggle('is-active', active);
      panel.inert = !active;
      panel.setAttribute('aria-hidden', String(!active));
    }
  }

  function closePanel({restoreFocus = false} = {}) {
    cancelTimers();
    const oldTrigger = triggers.find(button => button.dataset.navPanel === current);
    current = null;
    header.classList.remove('is-open');
    document.body.classList.remove('px-nav-expanded');
    mega.inert = true;
    mega.setAttribute('aria-hidden', 'true');
    for (const button of triggers) button.setAttribute('aria-expanded', 'false');
    for (const panel of panels) {
      panel.classList.remove('is-active');
      panel.inert = true;
      panel.setAttribute('aria-hidden', 'true');
    }
    if (restoreFocus && oldTrigger) {
      suppressFocusOpen = true;
      oldTrigger.focus({preventScroll:true});
      suppressFocusOpen = false;
    }
  }

  for (const trigger of triggers) {
    trigger.addEventListener('focus', () => {
      if (keyboardIntent && !suppressFocusOpen) openPanel(trigger.dataset.navPanel, true);
    });
    trigger.addEventListener('pointerenter', () => {
      if (!hasHover.matches || keyboardOpening && header.contains(document.activeElement)) return;
      cancelTimers();
      hoverTimer = setTimeout(() => openPanel(trigger.dataset.navPanel), current ? 65 : 110);
    });
    trigger.addEventListener('click', event => {
      const isKeyboard = event.detail === 0;
      if (current === trigger.dataset.navPanel && (!hasHover.matches || isKeyboard)) closePanel();
      else openPanel(trigger.dataset.navPanel, isKeyboard);
    });
    trigger.addEventListener('keydown', event => {
      if (event.key !== 'ArrowDown') return;
      event.preventDefault();
      openPanel(trigger.dataset.navPanel, true);
      document.getElementById(`nav-${trigger.dataset.navPanel}`).querySelector('a,button')?.focus();
    });
  }
  header.addEventListener('pointerenter', () => clearTimeout(closeTimer));
  mega.addEventListener('pointerenter', cancelTimers);
  header.addEventListener('pointerleave', () => {
    clearTimeout(hoverTimer);
    if (!hasHover.matches || keyboardOpening && header.contains(document.activeElement)) return;
    closeTimer = setTimeout(() => closePanel(), 220);
  });
  header.addEventListener('focusout', () => {
    setTimeout(() => {
      if (current && !header.contains(document.activeElement)) closePanel();
    }, 0);
  });
  scrim?.addEventListener('pointerdown', () => closePanel({restoreFocus:keyboardOpening}));
  document.addEventListener('keydown', event => {
    if (event.key === 'Escape' && current) {
      event.preventDefault();
      closePanel({restoreFocus:true});
    }
  });
  document.addEventListener('pointerdown', event => {
    if (current && !header.contains(event.target)) closePanel();
  });

  function closeMobile({restoreFocus = false} = {}) {
    if (!mobile?.open) return;
    mobile.close();
    document.body.classList.remove('px-nav-mobile-expanded');
    if (restoreFocus) burger?.focus({preventScroll:true});
  }
  burger?.addEventListener('click', () => {
    closePanel();
    mobile.showModal();
    document.body.classList.add('px-nav-mobile-expanded');
    mobile.querySelector('.px-nav-mobile-close').focus({preventScroll:true});
  });
  mobile?.querySelector('.px-nav-mobile-close').addEventListener('click', () => closeMobile({restoreFocus:true}));
  mobile?.addEventListener('cancel', event => {
    event.preventDefault();
    closeMobile({restoreFocus:true});
  });
  mobile?.addEventListener('close', () => document.body.classList.remove('px-nav-mobile-expanded'));
  mobile?.addEventListener('click', event => {
    if (event.target !== mobile) return;
    const bounds = mobile.getBoundingClientRect();
    if (event.clientX < bounds.left || event.clientX > bounds.right || event.clientY < bounds.top || event.clientY > bounds.bottom) closeMobile({restoreFocus:true});
  });

  // Close the navigation before the page's delegated topic / reader handler runs.
  function onNavigationAction(event) {
    const action = event.target.closest('a,[data-read],[data-topic-open]');
    if (!action) return;
    closePanel();
    closeMobile();
  }
  header.addEventListener('click', onNavigationAction);
  mobile?.addEventListener('click', onNavigationAction);
  desktop.addEventListener('change', () => { closePanel(); closeMobile(); });
  window.PXNavigation = Object.freeze({close: () => {closePanel(); closeMobile();}});
})();
